import { LandingComponentsConfig, LandingScreenSchema } from '@/modules/Landing/instances/@types/landing-types'
import japaneseWalkingFWebm from '@/assets/landing-videos/japanese-walking-f.webm'

const schema: LandingScreenSchema = {
	order: ['LandingHead', 'LandingTitle', 'LandingVideoAnimation', 'LandingProgressLoader', 'LandingFooter'],

	components: {
		LandingTitle: (): LandingComponentsConfig['LandingTitle'] => ({
			title: 'Japanese Walking for Weight Loss Based on Your Age',
			size: 'small',
			customStyles: {
				marginLeft: '2rem',
				marginRight: '2rem',
			},
		}),

		LandingVideoAnimation: (): LandingComponentsConfig['LandingVideoAnimation'] => ({
			url: japaneseWalkingFWebm,
			loop: true,
			customStyles: {
				height: '50vh',
			},
		}),

		LandingProgressLoader: (): LandingComponentsConfig['LandingProgressLoader'] => ({
			duration: 3500,
		}),
	},
}

export default schema
